export enum BOOKING_STATUSES {
  ACTIVE = "active",
  CANCELED = "canceled",
  PLANNED = "planned",
}

export enum BOOKING_PAY_LOCATIONS {
  DOCK = "dock",
  HOTEL = "hotel",
  HOTEL_CARD = "hotel_card",
  ONLINE = "online",
}

export enum PAYMENT_STATUSES {
  CREATED = "created",
  PENDING = "pending",
  PAID = "paid",
  FAILED = "failed",
  EXPIRED = "expired",
  CANCELLED = "cancelled",
}
